"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageTransport = void 0;
const transport_1 = require("../transport");
class MessageTransport extends transport_1.Transport {
    constructor(source, target, origin = '*') {
        super();
        this.source = source;
        this.target = target;
        this.origin = origin;
        this.handler = (event) => {
            if (event.data) {
                this.emit('message', event.data);
            }
        };
        this.source.addEventListener('message', this.handler);
    }
    send(message) {
        this.target.postMessage(message, this.origin);
    }
    dispose() {
        // remove listener
        this.source.removeEventListener('message', this.handler);
    }
}
exports.MessageTransport = MessageTransport;
//# sourceMappingURL=message.js.map